import type moment from "moment";
import React from "react";
import { ShowDatePickerProps } from "./models";
import SingleShowDatePicker from "./SingleShowDatepicker";

const AllDayDatePickers = (props: ShowDatePickerProps) => {
  const onStartDateChange = (newDate: moment.Moment) => {
    const newDisplayStartDate = newDate.clone().startOf("day");

    // When the start date changes (e.g. 2 days later than the previous start date), the end date should shift by the same amount (e.g. 2 days later than the previous end date)
    const startEndDifference = newDate.diff(props.showDates.startDisplayDate, "milliseconds");
    const newDisplayEndDate = props.showDates.endDisplayDate.clone().add(startEndDifference, "milliseconds");

    props.onDatesChange({
      startDisplayDate: newDisplayStartDate,
      endDisplayDate: newDisplayEndDate,

      timeOfPerformance: props.showDates.timeOfPerformance,
      mode: "allDay"
    });
  };

  const onEndDateChange = (newDate: moment.Moment) => {
    const displayEndDate = newDate.clone().startOf("day");

    props.onDatesChange({
      startDisplayDate: props.showDates.startDisplayDate,
      endDisplayDate: displayEndDate,
      timeOfPerformance: props.showDates.timeOfPerformance,
      mode: "allDay"
    });
  };

  return <>
    <div>
      <SingleShowDatePicker
        validatorKey="showStartDate"
        onDateChange={onStartDateChange}
        value={props.showDates.startDisplayDate}
      />
    </div>
    <div>
      {RESX.DateTime.UntilAndIncludingAbbreviated}
    </div>
    <div>
      <SingleShowDatePicker
        validatorKey="showEndDate"
        onDateChange={onEndDateChange}
        value={props.showDates.endDisplayDate}
      />
    </div>
  </>;
};

export default AllDayDatePickers;
